export const order_status_array = [
  "Pending",
  "Processing",
  "Dispatched",
  "Delivered",
  "Cancelled",
];

export const payment_status_array = ["Pending", "Completed", "Failed"];
